module.exports = __webpack_public_path__ + "img/weChatQR.368eaa64.png";